import { HeaderContext, SortingFnOption } from '@tanstack/react-table'
import { ReactNode } from 'react'

export const genericSorting = <T,>(
  sortingFn: SortingFnOption<T>,
  label: string | JSX.Element | ReactNode,
  sortDescFirst: boolean = false,
) => {
  return {
    sortingFn,
    sortDescFirst,
    sortUndefined: 'last' as false | -1 | 1 | 'first' | 'last',
    header: ({ column }: HeaderContext<T, unknown>) => (
      <span className='cursor-pointer' onClick={() => column.toggleSorting()}>
        {label}
      </span>
    ),
  }
}
